import styled from 'styled-components';
import { Box, Button, Link, Typography } from '@mui/material';
import { PaperWrapper as BasePaperWrapper } from '../../common/styled';
import pallet from '../../../layouts/pallet';
import { fontSizes } from '../../../layouts/fontSizes';

const HeaderBar = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const EnrolButton = styled(Button)`
  align-self: flex-end;
`;

const BusPaperWrapper = styled(BasePaperWrapper)`
  flex-direction: column;
  gap: 16px;
`;

const GridContainer = styled(Box)`
  width: 100%;
  position: relative;
`;

const LoaderOverlay = styled(Box)`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

const QrLink = styled(Link)`
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
  }
`;

const UnlinkButton = styled(Button)`
  background-color: ${pallet.unlinkRed} !important;
  color: ${pallet.white} !important;
  border-radius: 4px;
  box-shadow: 0px 2px 4px 0px ${pallet.unlinkBoxShadow};
  height: 30px !important;
  min-width: 76px !important;
  width: 76px !important;
  font-size: ${fontSizes.placeHolder} !important;
  &:hover {
    background-color: ${pallet.unlinkRed};
  }
  &:disabled {
    background-color: ${pallet.borderGrey} !important;
    color: ${pallet.white} !important;
    box-shadow: none !important;
  }
`;

const RightActions = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
`;

const ActionsContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 12
}));

const RefreshButton = styled(Button)(() => ({
  width: '138.85px',
  height: '40px !important'
}));

const Title = styled(Typography)({
  fontSize: '24px !important',
  fontWeight: 'bold !important'
});

export {
  HeaderBar,
  EnrolButton,
  BusPaperWrapper,
  GridContainer,
  LoaderOverlay,
  QrLink,
  UnlinkButton,
  RightActions,
  ActionsContainer,
  RefreshButton,
  Title
};
